import { makeAutoObservable, runInAction } from 'mobx';

import { cmApi } from '@src/api';
import type { CmApi, StepTypeDto } from '@src/api';

import { preloaderStore } from '../../preloaderStore';

type StepTypeDtoDefId = StepTypeDto & { id: string; name: string };

class StepTypesStore {
  stepTypes: StepTypeDtoDefId[] = [];

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.stepTypes.getStepTypes();

    runInAction(() => {
      this.stepTypes = data?.map((type) => ({ ...type, id: type.stepType ?? '', name: type.stepTypeText ?? '' })) ?? [];
    });
    preloaderStore.preloader(false);
  };
}

export const stepTypesStore = new StepTypesStore({ api: cmApi });
